import React from "react";
import "../../style/modalDialogs.css";

const ModalDialogs = () => {
  return (
    <div className="modal-page">
      <h1 className="page-title">Modal Dialogs</h1>

      <div className="modal-content-center">
        <p>Click on button to see modal</p>

        <div className="btn-group">
          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#smallModal"
          >
            Small Modal
          </button>

          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#largeModal"
          >
            Large Modal
          </button>
        </div>
      </div>

      {/* Small Modal */}
      <div
        className="modal fade"
        id="smallModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Small Modal</h5>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
             Show a second modal and hide this one with the button below.
            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Large Modal */}
      <div
        className="modal fade"
        id="largeModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Large Modal</h5>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              Show a second modal and hide this one with the button below.
            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDialogs;